module.exports = __webpack_public_path__ + "img/soundbutton.7f887009.svg";